import { useEffect } from 'react';
import { useAuth } from './auth/AuthContext';
import { Card, Typography, Button, Space } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import landing_image from './assets/MIMO-Home-Landing-Image.jpg';
import mimo_logo from './assets/Mimo_Logo_R.jpg';

const { Title, Text } = Typography;

export default function SignedOut() {
  const auth = useAuth();

  useEffect(() => {
    // Reset all auth state including isLoggingOut flag
    auth.resetAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        backgroundImage: `url(${landing_image})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px',
      }}
    >
      <Card
        style={{
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
          borderRadius: 8,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          padding: '32px 40px',
          backgroundColor: '#ffffff',
        }}
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div
            style={{ marginTop: -52, marginBottom: -72, display: 'flex', justifyContent: 'center' }}
          >
            <img
              src={mimo_logo}
              alt="Mimo Logo"
              style={{
                width: 140,
                height: 'auto',
                display: 'block',
              }}
            />
          </div>
          <div>
            <Title
              level={2}
              style={{ marginBottom: 8, fontSize: 28, fontWeight: 600, color: '#000000' }}
            >
              You're Signed Out
            </Title>
            <Text
              style={{
                fontSize: 15,
                color: 'rgba(0, 0, 0, 0.65)',
                display: 'block',
                marginBottom: 8,
              }}
            >
              Your session has ended. Click below to sign in again.
            </Text>
          </div>
          <Button
            type="primary"
            size="large"
            icon={<LoginOutlined />}
            onClick={auth.login}
            block
            style={{
              height: 48,
              fontSize: 16,
              fontWeight: 700,
              borderRadius: 4,
            }}
          >
            Sign in
          </Button>
          {/* KAN-180: the hosted sign-in labels the field "Username"; the email works there. */}
          <Text
            type="secondary"
            style={{ display: 'block', textAlign: 'center', marginTop: 12, fontSize: 13 }}
          >
            Sign in with your email address as the username.
          </Text>
        </Space>
      </Card>
    </div>
  );
}
